/* Product-page row driven by the visitor's own browsing history.
   Seeds Shopify's related-products recommendations with the last few products
   they actually looked at, merges the results and drops duplicates. */
(function () {
  var KEY = 'pelanva:viewed';

  function readHistory() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (x) { return x && x.id; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 20)));
    } catch (e) {
      /* private mode / quota - personalisation just stays off */
    }
  }

  class TasteRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      var id = this.dataset.currentId;
      var handle = this.dataset.currentHandle;
      var gender = this.dataset.currentGender || '';
      var history = readHistory();

      var others = history.filter(function (e) { return String(e.id) !== String(id); });

      // Only seed on products from the same department. Showing menswear on a
      // womenswear page reads as a bug, however honest the browsing history is.
      var pool = gender
        ? others.filter(function (e) { return (e.g || '') === gender; })
        : others;

      var seeds = pool.slice(0, parseInt(this.dataset.seeds || '3', 10));

      writeHistory([{ id: id, handle: handle, g: gender }].concat(others));

      if (!seeds.length) {
        this.hide();
        return;
      }

      this.load(seeds, handle);
    }

    hide() {
      var wrap = this.parentElement;
      if (wrap) wrap.style.display = 'none';
    }

    load(seeds, currentHandle) {
      var self = this;
      var base = this.dataset.url;
      var limit = parseInt(this.dataset.limit || '4', 10);

      Promise.all(
        seeds.map(function (seed) {
          return fetch(base + '&product_id=' + encodeURIComponent(seed.id))
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; });
        })
      ).then(function (pages) {
        var seen = {};
        var cards = [];
        seen[currentHandle] = true;
        seeds.forEach(function (s) { if (s.handle) seen[s.handle] = true; });

        pages.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('li.grid__item').forEach(function (li) {
            var a = li.querySelector('a[href*="/products/"]');
            if (!a) return;
            var h = a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
            if (seen[h]) return;
            seen[h] = true;
            cards.push(li);
          });
        });

        if (!cards.length) {
          self.hide();
          return;
        }

        // Interleave so no single seed dominates the row.
        var heading = document.createElement('h2');
        heading.className = 'q-taste__heading';
        heading.textContent = self.dataset.heading || '';

        var ul = document.createElement('ul');
        ul.className = self.dataset.gridClass || 'grid product-grid';
        ul.setAttribute('role', 'list');
        cards.slice(0, limit).forEach(function (li) { ul.appendChild(li); });

        self.innerHTML = '';
        self.appendChild(heading);
        self.appendChild(ul);
      });
    }
  }

  if (!customElements.get('taste-recommendations')) {
    customElements.define('taste-recommendations', TasteRecommendations);
  }
})();
